/** Curated lists for RFP structured fields (expand over time). */

/** Alphabetize option lists by label (locale-aware). */
export function sortOptionsByLabel(options) {
  return [...options].sort((a, b) => a.label.localeCompare(b.label, 'en', { sensitivity: 'base' }));
}

/** IAB standard display sizes (Lean / Ad Portfolio). Value = stable id; label includes WxH. */
export const IAB_DISPLAY_SIZE_OPTIONS = [
  { value: '180x150', label: '180 × 150 — Rectangle' },
  { value: '200x200', label: '200 × 200 — Small square' },
  { value: '250x250', label: '250 × 250 — Square' },
  { value: '300x250', label: '300 × 250 — Medium rectangle' },
  { value: '300x50', label: '300 × 50 — Mobile banner' },
  { value: '300x600', label: '300 × 600 — Half page' },
  { value: '300x1050', label: '300 × 1050 — Portrait' },
  { value: '320x50', label: '320 × 50 — Mobile banner' },
  { value: '320x480', label: '320 × 480 — Mobile interstitial' },
  { value: '336x280', label: '336 × 280 — Large rectangle' },
  { value: '728x90', label: '728 × 90 — Leaderboard' },
  { value: '970x90', label: '970 × 90 — Large leaderboard' },
  { value: '970x250', label: '970 × 250 — Billboard' },
  { value: '120x600', label: '120 × 600 — Skyscraper' },
  { value: '160x600', label: '160 × 600 — Wide skyscraper' },
  { value: '768x1024', label: '768 × 1024 — Tablet full page' },
];

/**
 * VAST-oriented video delivery (IAB Digital Video / VAST). Multi-select.
 */
export const VAST_VIDEO_OPTIONS = [
  { value: 'vast_2', label: 'VAST 2.x wrapper / inline' },
  { value: 'vast_3', label: 'VAST 3.x' },
  { value: 'vast_4', label: 'VAST 4.x (incl. 4.1 / 4.2)' },
  { value: 'linear_instream', label: 'Linear in-stream' },
  { value: 'nonlinear_overlay', label: 'Non-linear / overlay' },
  { value: 'vpaid_optional', label: 'VPAID / SIMID where applicable' },
  { value: 'duration_6', label: 'Max creative length :06' },
  { value: 'duration_15', label: 'Max creative length :15' },
  { value: 'duration_30', label: 'Max creative length :30' },
  { value: 'duration_60', label: 'Max creative length :60' },
  { value: 'podding', label: 'Ad podding / multiple spots' },
  { value: 'skippable', label: 'Skippable mid-roll allowed' },
  { value: 'hosting_mp4', label: 'Host MP4 / H.264 preferred' },
  { value: 'hosting_webm', label: 'WebM alternate acceptable' },
];

export const ATTRIBUTION_OPTIONS = [
  { value: 'pixel_web', label: 'Web pixel / impression tracker' },
  { value: 'pixel_app', label: 'In-app / SDK event' },
  { value: 'qr_code', label: 'QR code scan / landing' },
  { value: 'interactive', label: 'Interactive unit engagement' },
  { value: 'foot_traffic', label: 'Foot traffic / visit lift' },
  { value: 'matchback', label: 'Sales / match-back file' },
  { value: 'brand_lift', label: 'Brand lift study' },
  { value: 'mixed', label: 'Mixed / TBD with ops' },
];

export const DATA_PRIVACY_OPTIONS = [
  { value: 'ccpa', label: 'CCPA / CPRA (California)' },
  { value: 'coppa', label: 'COPPA (under-13)' },
  { value: 'gdpr', label: 'GDPR (EU data subjects)' },
  { value: 'state_privacy', label: 'Other US state privacy laws' },
  { value: 'gaming_alcohol', label: 'Gaming / alcohol advertising rules' },
  { value: 'none_claimed', label: 'No special category claimed' },
  { value: 'legal_review', label: 'Legal review required before launch' },
];

export const PROPOSAL_FORMAT_OPTIONS = [
  { value: 'pdf_email', label: 'PDF via email' },
  { value: 'ppt', label: 'PowerPoint deck' },
  { value: 'excel', label: 'Excel rate / allocation workbook' },
  { value: 'live_review', label: 'Live review (call / screen share)' },
  { value: 'portal', label: 'Upload to buyer portal' },
  { value: 'combined', label: 'Combined package (PDF + Excel)' },
];

export const COUNTRY_OPTIONS = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'MX', label: 'Mexico' },
  { value: 'other', label: 'Other (notes)' },
];

export const US_STATE_OPTIONS = [
  { value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' }, { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' }, { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' }, { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' },
];

export const INTERCEPT_SPOT_LENGTH_OPTIONS = [
  { value: 'sec_6', label: ':06' },
  { value: 'sec_15', label: ':15' },
  { value: 'sec_30', label: ':30' },
  { value: 'sec_60', label: ':60' },
  { value: 'sec_90', label: ':90' },
  { value: 'sec_120', label: ':120' },
  { value: 'custom_ops', label: 'Custom (ops confirms)' },
];

export const KPI_PRIMARY_OPTIONS = [
  { value: 'cpm', label: 'CPM (impressions)' },
  { value: 'cpc', label: 'CPC' },
  { value: 'cpa', label: 'CPA / conversions' },
  { value: 'ctr', label: 'CTR' },
  { value: 'roas', label: 'ROAS / revenue' },
  { value: 'reach_freq', label: 'Reach & frequency' },
  { value: 'foot_traffic', label: 'Foot traffic / store visits' },
  { value: 'brand_lift', label: 'Brand lift / awareness' },
  { value: 'sov', label: 'Share of voice' },
  { value: 'other', label: 'Other (describe in notes)' },
];

export const KPI_SECONDARY_OPTIONS = [
  { value: 'cpm', label: 'CPM' },
  { value: 'cpc', label: 'CPC' },
  { value: 'cpa', label: 'CPA' },
  { value: 'ctr', label: 'CTR' },
  { value: 'vcr', label: 'VCR (video)' },
  { value: 'viewability', label: 'Viewability %' },
  { value: 'completion_rate', label: 'Completion rate' },
  { value: 'attribution', label: 'Multi-touch attribution' },
  { value: 'incrementality', label: 'Incrementality study' },
];

export const AGE_BLOCK_OPTIONS = [
  { value: '21_34', label: '21–34' },
  { value: '35_49', label: '35–49' },
  { value: '50_64', label: '50–64' },
  { value: '65_plus', label: '65+' },
  { value: '18_54', label: '18–54 (broad)' },
  { value: '25_54', label: '25–54' },
  { value: 'custom_mix', label: 'Mixed / TBD in notes' },
];

export const GENDER_AUDIENCE_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'both', label: 'Both / all genders' },
];

export const HHI_OPTIONS = [
  { value: 'lt40k', label: 'Under $40K' },
  { value: '40_60k', label: '$40K–$60K' },
  { value: '60_75k', label: '$60K–$75K' },
  { value: '75_100k', label: '$75K–$100K' },
  { value: '100_150k', label: '$100K–$150K' },
  { value: '150_200k', label: '$150K–$200K' },
  { value: '200k_plus', label: '$200K+' },
  { value: 'index_100_plus', label: 'Index 100+ vs US HH' },
  { value: 'affluent', label: 'Affluent / HHI 150K+ focus' },
];

export const PSYCHOGRAPHIC_OPTIONS = [
  { value: 'sports_enthusiast', label: 'Sports enthusiast' },
  { value: 'casino_gaming', label: 'Casino / gaming' },
  { value: 'nightlife', label: 'Nightlife / entertainment' },
  { value: 'foodie', label: 'Dining / foodie' },
  { value: 'travel', label: 'Travel' },
  { value: 'family', label: 'Family-focused' },
  { value: 'luxury', label: 'Luxury / premium' },
  { value: 'value_seeker', label: 'Value / deal seeker' },
  { value: 'loyalty_heavy', label: 'High loyalty program engagement' },
  { value: 'commuter', label: 'Commuter / on-the-go' },
  { value: 'localist', label: 'Local community–oriented' },
];

/** Top US DMAs (Nielsen-style names); add more in product as needed */
export const DMA_OPTIONS = [
  { value: 'new_york', label: 'New York' },
  { value: 'los_angeles', label: 'Los Angeles' },
  { value: 'chicago', label: 'Chicago' },
  { value: 'philadelphia', label: 'Philadelphia' },
  { value: 'dallas_ft_worth', label: 'Dallas–Ft. Worth' },
  { value: 'washington_dc', label: 'Washington, DC (Hagerstown)' },
  { value: 'houston', label: 'Houston' },
  { value: 'boston', label: 'Boston (Manchester)' },
  { value: 'atlanta', label: 'Atlanta' },
  { value: 'phoenix', label: 'Phoenix' },
  { value: 'tampa', label: 'Tampa–St. Petersburg' },
  { value: 'seattle', label: 'Seattle–Tacoma' },
  { value: 'detroit', label: 'Detroit' },
  { value: 'minneapolis', label: 'Minneapolis–St. Paul' },
  { value: 'miami', label: 'Miami–Ft. Lauderdale' },
  { value: 'denver', label: 'Denver' },
  { value: 'orlando', label: 'Orlando' },
  { value: 'cleveland', label: 'Cleveland–Akron' },
  { value: 'sacramento', label: 'Sacramento' },
  { value: 'st_louis', label: 'St. Louis' },
  { value: 'portland', label: 'Portland, OR' },
  { value: 'charlotte', label: 'Charlotte' },
  { value: 'indianapolis', label: 'Indianapolis' },
  { value: 'san_antonio', label: 'San Antonio' },
  { value: 'kansas_city', label: 'Kansas City' },
  { value: 'columbus', label: 'Columbus, OH' },
  { value: 'milwaukee', label: 'Milwaukee' },
  { value: 'las_vegas', label: 'Las Vegas' },
  { value: 'nashville', label: 'Nashville' },
  { value: 'austin', label: 'Austin' },
  { value: 'omaha', label: 'Omaha' },
  { value: 'albuquerque', label: 'Albuquerque' },
  { value: 'oklahoma_city', label: 'Oklahoma City' },
  { value: 'memphis', label: 'Memphis' },
  { value: 'louisville', label: 'Louisville' },
  { value: 'new_orleans', label: 'New Orleans' },
  { value: 'salt_lake_city', label: 'Salt Lake City' },
  { value: 'birmingham', label: 'Birmingham' },
  { value: 'greensboro', label: 'Greensboro' },
  { value: 'jacksonville', label: 'Jacksonville' },
  { value: 'raleigh_durham', label: 'Raleigh–Durham' },
  { value: 'illinois_wi_border', label: 'IL / WI border markets' },
  { value: 'nebraska', label: 'Nebraska' },
  { value: 'arizona', label: 'Arizona' },
  { value: 'other_dma', label: 'Other (notes)' },
];

export const CBSA_OPTIONS = [
  { value: 'chicago_naperville_elgin', label: 'Chicago–Naperville–Elgin, IL-IN-WI' },
  { value: 'new_york_newark_jersey_city', label: 'New York–Newark–Jersey City, NY-NJ-PA' },
  { value: 'los_angeles_long_beach', label: 'Los Angeles–Long Beach–Anaheim, CA' },
  { value: 'dallas_fort_worth_arlington', label: 'Dallas–Fort Worth–Arlington, TX' },
  { value: 'houston_woodlands_sugar_land', label: 'Houston–The Woodlands–Sugar Land, TX' },
  { value: 'washington_arlington_alexandria', label: 'Washington–Arlington–Alexandria, DC-VA-MD-WV' },
  { value: 'miami_fort_lauderdale', label: 'Miami–Fort Lauderdale–West Palm Beach, FL' },
  { value: 'phoenix_mesa_scottsdale', label: 'Phoenix–Mesa–Scottsdale, AZ' },
  { value: 'boston_cambridge_newton', label: 'Boston–Cambridge–Newton, MA-NH' },
  { value: 'atlanta_sandy_springs', label: 'Atlanta–Sandy Springs–Alpharetta, GA' },
  { value: 'philadelphia_camden_wilmington', label: 'Philadelphia–Camden–Wilmington, PA-NJ-DE-MD' },
  { value: 'detroit_warren_dearborn', label: 'Detroit–Warren–Dearborn, MI' },
  { value: 'seattle_tacoma_bellevue', label: 'Seattle–Tacoma–Bellevue, WA' },
  { value: 'minneapolis_st_paul_bloomington', label: 'Minneapolis–St. Paul–Bloomington, MN-WI' },
  { value: 'denver_aurora_lakewood', label: 'Denver–Aurora–Lakewood, CO' },
  { value: 'st_louis', label: 'St. Louis, MO-IL' },
  { value: 'omaha_council_bluffs', label: 'Omaha–Council Bluffs, NE-IA' },
  { value: 'lincoln', label: 'Lincoln, NE' },
  { value: 'other_cbsa', label: 'Other CBSA (notes)' },
];

export const VENUE_TYPE_GEO_OPTIONS = [
  { value: 'casino_resort', label: 'Casino / resort' },
  { value: 'gaming_floor', label: 'Gaming floor screens' },
  { value: 'sports_bar', label: 'Sports bar / restaurant' },
  { value: 'atm_lobby', label: 'ATM / lobby kiosk' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'retail_mall', label: 'Retail / mall' },
  { value: 'transit', label: 'Transit / OOH adjacent' },
  { value: 'stadium_arena', label: 'Stadium / arena' },
  { value: 'mixed_venue', label: 'Mixed venue types' },
];

export const CONTEXTUAL_PREF_OPTIONS = [
  { value: 'gaming_floor', label: 'Gaming floor' },
  { value: 'atm_lobby', label: 'ATM lobby' },
  { value: 'sports_bar', label: 'Sports bar' },
  { value: 'high_dwell', label: 'High dwell time zones' },
  { value: 'premium_adjacency', label: 'Premium content adjacency' },
  { value: 'no_competitive', label: 'Strict competitive separation' },
  { value: 'daypart_prime', label: 'Prime dayparts only' },
];

export const FIRST_PARTY_DATA_OPTIONS = [
  { value: 'crm_match', label: 'CRM / email match' },
  { value: 'loyalty_file', label: 'Loyalty program file' },
  { value: 'pixel_site', label: 'Site / app pixel audience' },
  { value: 'no_first_party', label: 'No first-party match' },
  { value: 'tbd_file', label: 'File TBD — sales to coordinate' },
];

export const RETARGETING_OPTIONS = [
  { value: 'site_retarget', label: 'Site / visit retargeting' },
  { value: 'crm_retarget', label: 'CRM / list retargeting' },
  { value: 'lookalike', label: 'Lookalike modeling' },
  { value: 'frequency_cap_strict', label: 'Strict frequency cap' },
  { value: 'none', label: 'None' },
  { value: 'tbd', label: 'TBD with sales' },
];

export const PLACEMENT_CHANNEL_OPTIONS = [
  { value: 'digital_display', label: 'Digital display' },
  { value: 'video_dooh', label: 'Video / DOOH' },
  { value: 'tv_intercept', label: 'TV intercept / linear addressable' },
  { value: 'mobile_geo', label: 'Mobile / geo-fenced' },
  { value: 'audio', label: 'Digital audio' },
  { value: 'programmatic_pmp', label: 'Programmatic / PMP' },
  { value: 'direct_io', label: 'Direct IO / guaranteed' },
];

export const PRICING_MODEL_OPTIONS = [
  { value: 'cpm', label: 'CPM' },
  { value: 'flat', label: 'Flat fee' },
  { value: 'cpc', label: 'CPC' },
  { value: 'cpa', label: 'CPA' },
  { value: 'sov', label: 'Share of voice (SOV)' },
  { value: 'hybrid', label: 'Hybrid / package' },
];

export const COMMISSION_STRUCTURE_OPTIONS = [
  { value: 'agency_standard', label: 'Agency standard (per IO)' },
  { value: '15_gross', label: '15% gross' },
  { value: '10_net', label: '10% net' },
  { value: 'fixed_fee', label: 'Fixed agency fee' },
  { value: 'none', label: 'No agency commission' },
  { value: 'tbd', label: 'TBD / legal to confirm' },
];

export const DAYPART_OPTIONS = [
  { value: 'all_day', label: 'All day / run of schedule' },
  { value: 'morning', label: 'Morning (6a–12p local)' },
  { value: 'afternoon', label: 'Afternoon (12p–5p)' },
  { value: 'evening', label: 'Evening (5p–11p)' },
  { value: 'late_night', label: 'Late night (11p–6a)' },
  { value: 'weekends', label: 'Weekends only' },
  { value: 'weekdays', label: 'Weekdays only' },
  { value: 'prime', label: 'Prime dayparts (venue-defined)' },
];

export const BLACKOUT_PRESET_OPTIONS = [
  { value: 'none', label: 'No blackouts' },
  { value: 'major_holidays', label: 'Major US holidays' },
  { value: 'super_bowl_week', label: 'Super Bowl week' },
  { value: 'election_window', label: 'Election / political windows' },
  { value: 'venue_blackout', label: 'Venue-specific blackout calendar' },
  { value: 'custom_dates', label: 'Custom dates (use notes + flight dates)' },
];

export const FLIGHT_PATTERN_OPTIONS = [
  { value: 'even', label: 'Even delivery' },
  { value: 'front_loaded', label: 'Front-loaded' },
  { value: 'event_driven', label: 'Event-driven bursts' },
  { value: 'pacing_tbd', label: 'Pacing TBD with ops' },
];

export const AD_FORMAT_OPTIONS = [
  { value: 'display', label: 'Display' },
  { value: 'video', label: 'Video' },
  { value: 'dooh', label: 'DOOH full motion' },
  { value: 'static_dooh', label: 'Static DOOH' },
  { value: 'interstitial', label: 'Interstitial' },
  { value: 'native', label: 'Native' },
  { value: 'audio', label: 'Audio' },
  { value: 'ctv', label: 'CTV / streaming' },
];

export const SCREEN_VENUE_TYPE_OPTIONS = [
  { value: 'gaming_screen', label: 'Gaming screen' },
  { value: 'bar_restaurant', label: 'Bar / restaurant TV' },
  { value: 'atm_kiosk', label: 'ATM / kiosk display' },
  { value: 'lobby_board', label: 'Lobby / directory board' },
  { value: 'outdoor', label: 'Outdoor / street-facing' },
  { value: 'mixed', label: 'Mixed screen types' },
];

export const PLACEMENT_RESTRICTION_OPTIONS = [
  { value: 'no_alcohol_adj', label: 'No alcohol adjacency' },
  { value: 'no_gaming_adj', label: 'No gaming adjacency' },
  { value: 'family_safe', label: 'Family-safe content only' },
  { value: 'premium_placements', label: 'Premium placements only' },
  { value: 'no_remessaging', label: 'No competitive remessaging' },
  { value: 'none', label: 'No special restrictions' },
];

export const SHARE_OF_VOICE_OPTIONS = [
  { value: 'standard', label: 'Standard rotation' },
  { value: 'sov_25', label: 'SOV ~25%' },
  { value: 'sov_50', label: 'SOV ~50%' },
  { value: 'sov_75', label: 'SOV ~75%' },
  { value: 'exclusive', label: 'Exclusive / roadblock' },
  { value: 'tbd', label: 'TBD' },
];

export const ROADBLOCK_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'daypart_roadblock', label: 'Daypart roadblock' },
  { value: 'venue_takeover', label: 'Venue takeover' },
  { value: 'event_spike', label: 'Event spike package' },
  { value: 'tbd', label: 'TBD' },
];

export const FREQUENCY_CAP_OPTIONS = [
  { value: 'standard_3', label: '3 per day / 10 per week (standard)' },
  { value: 'light_1', label: '1 per day / light touch' },
  { value: 'heavy_5', label: '5+ per day / heavy retarget' },
  { value: 'custom_ops', label: 'Custom — ops to confirm' },
  { value: 'none_specified', label: 'Not specified' },
];
